import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.mjs';

function parseFloatOrAuto(value) {
  let parsed = value;
  if (value && value !== 'auto') {
    parsed = parseFloat(value);
  }
  return parsed;
}
export default class GenericSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.classList.contains('swiper') ? this : this.querySelector('.swiper');
  }

  initializeOptions() {
    const dataset = this.slider.dataset;
    const slidesPerView = parseFloatOrAuto(dataset.slidesPerView);
    const slidesPerViewMobile = parseFloatOrAuto(dataset.slidesPerViewMobile);
    // Default options
    this.options = {
      slidesPerView: slidesPerViewMobile || slidesPerView || 1,
      spaceBetween: parseInt(dataset.spaceBetweenMobile || dataset.spaceBetween) || 0,
      slidesPerGroup: parseFloat(dataset.slidesPerGroupMobile || dataset.slidesPerGroup) || 1,
      observer: dataset.observer === 'true',
      noSwipingClass: 'swiper-no-swiping-mobile swiper-no-swiping',
      breakpoints: {
        1000: {
          slidesPerView: slidesPerView || 1,
          slidesPerGroup: parseFloat(dataset.slidesPerGroup) || 1,
          spaceBetween: parseInt(dataset.spaceBetween) || 0,
          noSwipingClass: 'swiper-no-swiping',
        },
      },
      a11y: {
        slideRole: dataset.slideRole || 'group',
      },
      on: {},
    };

    if (this.options.observer) {
      this.options.on.observerUpdate = function () {
        this.update();
      };
    }

    // Pagination
    if (this.querySelector('.swiper-pagination')) {
      this.options.pagination = {
        el: this.querySelector('.swiper-pagination'),
        type: dataset.paginationType || 'bullets',
        clickable: dataset.paginationClickable === 'true',
      };
    }

    // Navigation
    if (this.querySelector('.swiper-button-next') || this.querySelector('.swiper-button-prev')) {
      this.options.navigation = {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev'),
      };
    }

    // Scrollbar
    if (this.querySelector('.swiper-scrollbar')) {
      this.options.scrollbar = {
        el: this.querySelector('.swiper-scrollbar'),
        clickable: true,
      };
    }

    const autoPlayCheck = () => {
      this.options.autoplay = {
        delay: dataset.autoplayDelay ? parseInt(dataset.autoplayDelay) * 1000 : 3000,
        disableOnInteraction: dataset.disableOnInteraction !== 'false',
        pauseOnMouseEnter: dataset.pauseOnMouseEnter === 'true',
      };
    };

    // Autoplay
    if (dataset.autoplay === 'true') {
      autoPlayCheck();
    }

    if (dataset.autoplayButton) {
      const _that = this;
      const autoplayButton = _that.querySelector(dataset.autoplayButton);

      if (autoplayButton) {
        autoPlayCheck();

        _that.options.on.init = function (swiper) {
          const EVENTS = ['click', 'keydown'];

          if (!dataset?.autoplay) {
            swiper.autoplay.stop();
          }

          EVENTS.forEach((eventType) => {
            autoplayButton.addEventListener(eventType, (event) => {
              if (eventType === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
              event.preventDefault();

              if (swiper.autoplay.running) {
                swiper.autoplay.stop();
              } else {
                swiper.autoplay.start();
              }

              _that.updateButtonState(autoplayButton, swiper.autoplay.running);
            });
          });

          _that.updateButtonState(autoplayButton, swiper.autoplay.running);
        };
      }
    }

    // Additional Swiper options from JSON
    if (dataset.swiperOptions) {
      try {
        const additionalOptions = JSON.parse(dataset.swiperOptions);
        this.options = { ...this.options, ...additionalOptions };
      } catch (e) {
        console.warn('Invalid swiper options JSON:', dataset.swiperOptions);
      }
    }
  }

  updateButtonState(button, isPlaying) {
    const label = isPlaying
      ? button.dataset.pauseLabel || 'Pause autoplay'
      : button.dataset.playLabel || 'Play autoplay';

    button.setAttribute('aria-pressed', isPlaying);
    button.setAttribute('aria-label', label);
  }

  connectedCallback() {
    try {
      if (this.slider) {
        this.initializeOptions();
        this.swiper = new Swiper(this.slider, this.options);
      } else {
        throw new Error('No .swiper element found');
      }
    } catch (e) {
      console.error('Error initializing GenericSlider:', e);
    }
  }
}

// Define the custom element only if it hasn't been defined yet
if (!customElements.get('generic-slider')) {
  customElements.define('generic-slider', GenericSlider);
}
